<nz-page-header
  class="page-header"
  [nzTitle]="header"
  [nzSubtitle]="cardExtra"
  *ngIf="source$ | async | size"
>
  <nz-page-header-extra>
    <app-button-dropdown></app-button-dropdown>
  </nz-page-header-extra>
  <nz-page-header-content> </nz-page-header-content>
</nz-page-header>
<nz-divider *ngIf="source$ | async | size"></nz-divider>
<app-layout-list
  *ngIf="source$ | async | size; else noResults"
  [card]="card"
  [new]="new"
  [source]="source$ | async"
></app-layout-list>

<ng-template #card let-item let-position="idx">
  <nz-card
    nzHoverable
    class="cardDocument"
    [nzTitle]="documentTitle"
    [nzExtra]="documentExtra"
    (click)="$event.stopPropagation()"
  >
    <ng-template #documentExtra>
      <button
        nz-button
        nzType="text"
        (click)="$event.stopPropagation()"
        nz-dropdown
        nzShape="circle"
        [nzDropdownMenu]="documentCardExtraButton"
        nzPlacement="bottomRight"
        nzTrigger="click"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
    </ng-template>

    <nz-dropdown-menu #documentCardExtraButton="nzDropdownMenu">
      <ul nz-menu>
        <li
          nz-menu-item
          (click)="$event.stopPropagation(); onDowloadFile(item)"
        >
          <nz-row nzAlign="top" nzGutter="8" nzJustify="start">
            <nz-col nzSpan="6">
              <mat-icon>file_download</mat-icon>
            </nz-col>
            <nz-col nzSpan="2">
              <nz-divider nzOrientation="center" nzType="vertical"></nz-divider>
            </nz-col>
            <nz-col nzSpan="16">Exporter</nz-col>
          </nz-row>
        </li>
        <li nz-menu-divider></li>
        <li
          nz-menu-item
          nzDanger
          (click)="$event.stopPropagation()"
          nz-popconfirm
          nzPopconfirmTitle="Voulez-vous supprimer ce document ?"
          nzPopconfirmPlacement="bottom"
          (nzOnConfirm)="onDelete(item)"
          (nzOnCancel)="onCancel()"
        >
          <nz-row nzAlign="top" nzGutter="8" nzJustify="start">
            <nz-col nzSpan="6">
              <mat-icon>delete</mat-icon>
            </nz-col>
            <nz-col nzSpan="2">
              <nz-divider nzOrientation="center" nzType="vertical"></nz-divider>
            </nz-col>
            <nz-col nzSpan="16"> Supprimer </nz-col>
          </nz-row>
        </li>
      </ul>
    </nz-dropdown-menu>

    <div class="cardDocumentTitle">
      <nz-row nzAlign="middle" nzGutter="8" nzJustify="start">
        <nz-col nzSpan="24">
          <strong nz-typography>{{ item.title | carLimitation: 30 }}</strong>
        </nz-col>
      </nz-row>
      <nz-space nzDirection="vertical" nzSize="small"></nz-space>
      <nz-row nzAlign="top" nzGutter="8" nzJustify="start">
        <nz-col nzSpan="12">
          <nz-tag nzColor="geekblue" class="tagExtension">{{
            item?.type | carLimitation: 15
          }}</nz-tag>
        </nz-col>
        <nz-col nzSpan="12">
          <nz-tag nzColor="geekblue" class="tagExtension">{{
            item?.extension | carLimitation: 15
          }}</nz-tag>
        </nz-col>
      </nz-row>
    </div>
    <nz-divider nzOrientation="center" nzType="horizontal"></nz-divider>
    <nz-row nzAlign="top" nzGutter="8" nzJustify="start">
      <nz-col nzSpan="12">
        <app-avatar-group [source]="[item.auteur]"></app-avatar-group>
      </nz-col>
      <nz-col nzSpan="12">
        <small>{{ item?.dateStart | dateFr: "small" }}</small>
      </nz-col>
    </nz-row>
  </nz-card>
</ng-template>

<ng-template #new>
  <app-card-new
    [type]="'document'"
    [height]="'275px'"
    [width]="'300px'"
    [title]="newCardTitle"
    [description]="''"
    [definition]="newCardDefinition"
    (add)="onNewDocument($event)"
  ></app-card-new>
</ng-template>
<ng-template #documentTitle>
  <app-header-title [icon]="'insert_drive_file'"></app-header-title>
</ng-template>

<ng-template #header>
  <nz-row nzAlign="middle" nzGutter="8" nzJustify="start">
    <nz-col nzSpan="24">
      <h4 nz-typography>Documents</h4>
    </nz-col>
  </nz-row>
</ng-template>
<ng-template #cardExtra>
  <nz-row nzAlign="middle" nzGutter="8" nzJustify="start">
    <nz-col nzSpan="24">
      <nz-badge [nzCount]="source$ | async | size" [nzOverflowCount]="99">
      </nz-badge>
    </nz-col>
  </nz-row>
</ng-template>

<ng-template #noData>
  <nz-empty></nz-empty>
</ng-template>

<ng-template #unknownExtension>
  <i nz-icon nzType="file-unknown"></i>
</ng-template>

<ng-template #noResults>
  <app-no-result
    (new)="onNewDocument($event)"
    [icon]="'insert_drive_file'"
    [addtitle]="'Ajouter un document'"
    [notitle]="'Aucun document trouvé'"
  ></app-no-result>
</ng-template>

<ng-template #documentTitleForm>
  <app-header-title
    [icon]="'insert_drive_file'"
    [title]="newCardTitle"
  ></app-header-title>
</ng-template>
